import { render, staticRenderFns } from "./mod3-2.vue?vue&type=template&id=4d4a7267&scoped=true&"
import script from "./mod3-2.vue?vue&type=script&lang=js&"
export * from "./mod3-2.vue?vue&type=script&lang=js&"
import style0 from "./mod3-2.vue?vue&type=style&index=0&id=4d4a7267&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4a7267",
  null
  
)

export default component.exports